export default __webpack_public_path__ + "static/media/excel-logo.e35e6730.png";